import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { DarkModeContextProvider } from "./store/DarkModeContext";
import classes from "./index.css";
import App from "./App";
import * as global_en from "./locales/en/global.json";
import * as global_pt from "./locales/pt/global.json";
import * as global_es from "./locales/es/global.json";
import * as global_fr from "./locales/fr/global.json";


import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
import { AuthContextProvider } from "./store/AuthContext";
import { SidebarContextProvider } from "./store/SidebarContext";

i18next.init({
  interpolation: { escapeValue: false },
  lng: "pt",
  resources: {
    en: {
      global: global_en
        },
    pt: {
      global: global_pt
    },
    es: {
      global: global_es
    },
    fr: {
      global: global_fr,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <DarkModeContextProvider>
      <AuthContextProvider>
        <SidebarContextProvider>
          <I18nextProvider i18n={i18next}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </I18nextProvider>
        </SidebarContextProvider>
      </AuthContextProvider>
    </DarkModeContextProvider>
  </React.StrictMode>
);
